"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.imgix = void 0;
const md5_1 = __importDefault(require("md5"));
const services_1 = require("../services");
const stringify_1 = require("../utils/stringify");
const imgix = (config) => {
    return (mode, src, { width, height, quality = services_1.DEFAULT_IMG_QUALITY }) => {
        if (!(0, services_1.validateResizeOptions)(mode, { width, height }))
            return src;
        const params = {
            fit: { crop: "crop", resize: "clip" }[mode],
            height,
            width,
            quality,
            auto: "format",
        };
        const path = `/${encodeURIComponent(src)}`;
        const query = `?${(0, stringify_1.stringify)(params)}`;
        const signature = (0, md5_1.default)(config.token + path + query);
        return `${config.endpoint}${path}${query}&s=${signature}`;
    };
};
exports.imgix = imgix;
